import { gaV4AddToCart, getGraphqlIdFromDBId, getDBIdFromGraphqlId } from '@src/core/utils';
import { getPriceInfoFromProduct } from '@src/utils';
import { AddCartModalProduct, AddCartModalProductVariant } from '@src/utils/types';
import { pixelAddToCart } from '@src/utils/pixel';

export function getCartLineVariables(variantId: string, quantity: number = 1) {
  return {
    lines: [
      {
        variantId: variantId,
        quantity: quantity,
      },
    ],
  };
}

export function getAddToCartVariables(token: string, variantId: string, quantity: number = 1) {
  const cartId = getGraphqlIdFromDBId(token, 'Cart');
  const defaultVariables = getCartLineVariables(variantId, quantity);
  const variables = Object.assign(defaultVariables, { cartId });

  return variables;
}

export function addToCartMutationSuccessCallback(
  data,
  product: AddCartModalProduct,
  variant: AddCartModalProductVariant,
  previousPage: string,
) {
  if (data?.data?.cartLineAdd?.cart) {
    const productDBId = getDBIdFromGraphqlId(product.id);
    const productName = product.name;
    const productCategoryName = product.category.name;
    const { finalPrice, discountPrice } = getPriceInfoFromProduct(product);

    const variantGraphqlId = variant?.id;
    const variantSku = variant?.sku || '';
    const variantPrice = variant?.price.amount;
    const variantId = getDBIdFromGraphqlId(variantGraphqlId);

    // 가장 마지막에 추가한 Product Type을 localStorage에 저장
    localStorage.setItem('recentlyAddedProductType', JSON.stringify(product.productType.isMgs ? 'mgs' : 'maccaron'));

    pixelAddToCart(variantSku, product.name, productCategoryName, finalPrice);
    gaV4AddToCart(previousPage, productDBId, productName, variantId, variantPrice, discountPrice);
  }
}

export function stateOfProductForAddToCart(product: AddCartModalProduct) {
  const isAllVariantsEndOfLife = product?.variants.every((variant) => variant.isEndOfLife);
  const isAllVariantsOutOfStock = product?.availability?.isOutOfStock;

  // 1st : Check EOL
  if (isAllVariantsEndOfLife && isAllVariantsOutOfStock) return 'discontinued';

  const hasMultipleVariants = product?.productType?.hasVariants && product.variants.length > 1;

  // 2nd : Check Stock
  if (isAllVariantsOutOfStock) {
    if (hasMultipleVariants) {
      return 'notifyMe';
    } else {
      if (product?.variants[0]?.notifyme?.isNotified === false) {
        return 'notifyRequested';
      } else if (product?.variants[0]?.notifyme === null || product?.variants[0]?.notifyme?.isNotified === true) {
        return 'notifyMe';
      }
    }
  }

  // 3rd
  return 'addToCart';
}

export function StateOfVariantForAddToCart(variant: AddCartModalProductVariant) {
  if (variant) {
    // 1st
    if (variant?.isEndOfLife && variant?.stockQuantity <= 0) {
      return 'discontinued';
    }
    // 2nd
    if (!variant?.isEndOfLife && variant?.stockQuantity <= 0) {
      if (variant?.notifyme?.isNotified === false) {
        return 'notifyRequested';
      } else if (variant?.notifyme === null || variant?.notifyme?.isNotified === true) {
        return 'notifyMe';
      }
    }
    return 'addToCart';
  } else {
    return 'addToCart';
  }
}
